const CHUNK_RELOAD_KEY = 'chunk_error_reload';
const RELOAD_COOLDOWN_MS = 5000;

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  const message = error.message.toLowerCase();
  const name = error.name.toLowerCase();

  // rspack/webpack chunk load errors
  if (name === 'chunkloaderror') {
    return true;
  }

  // dynamic import failures
  if (
    message.includes('loading chunk') ||
    message.includes('failed to fetch dynamically imported module') ||
    message.includes('error loading dynamically imported module') ||
    message.includes("couldn't load chunk") ||
    message.includes('loading css chunk')
  ) {
    return true;
  }

  return false;
}

export function handleChunkLoadError(): void {
  const lastReload = sessionStorage.getItem(CHUNK_RELOAD_KEY);
  const now = Date.now();

  // prevent reload loops by checking if we recently reloaded
  if (lastReload && now - parseInt(lastReload, 10) < RELOAD_COOLDOWN_MS) {
    console.error(
      'Chunk load error detected but skipping reload to prevent loop',
    );
    return;
  }

  sessionStorage.setItem(CHUNK_RELOAD_KEY, now.toString());
  window.location.reload();
}
